/**
 *
 * @param {object} technic machine object
 * @param {object} overriddenParams
 * @param {boolean} overriddenParams.showModel show model in title or not
 * @param {boolean} overriddenParams.showRegistrationNumber show registration number in title or not
 * @param {boolean} overriddenParams.showHouseholdNumber show household
 * @param {boolean} overriddenParams.showVinNumber show vin number in title or not
 * @param {boolean} overriddenParams.showInventoryNumber show inventory number in title or not
 * @param {string} overriddenParams.titleIfEmpty title if technic is empty
 * @returns {string} formatted title
 */

export const getMachineTitle = (technic, overriddenParams) => {
	if(!technic || Object.keys(technic).length === 0) return null

	const defaultParams = {
		showModel: true,
		showRegistrationNumber: true,
		showHouseholdNumber: false,
		showVinNumber: false,
		showInventoryNumber: false,
		titleIfEmpty: null
	}

	const params = Object.assign(defaultParams, overriddenParams)


	const numberAttrsToAddingToTitle = []

	if (params.showRegistrationNumber) numberAttrsToAddingToTitle.push('registration_number')
	if (params.showHouseholdNumber) numberAttrsToAddingToTitle.push('household_number')
	if (params.showVinNumber) numberAttrsToAddingToTitle.push('vin_number')
	if (params.showInventoryNumber) numberAttrsToAddingToTitle.push('inventory_number')


	const canShowFewNumbers = numberAttrsToAddingToTitle.length > 1

	let title = ''
	if (technic.brand) {
		title += technic.brand
	}
	if (params.showModel && technic.model) {
		title += ` ${technic.model}`
	}

	if (canShowFewNumbers) {
		title += ' ( '

		title += numberAttrsToAddingToTitle
							.map((numberAttr) => {
									if (technic[numberAttr]) {
										return technic[numberAttr]
									}
							})
							.join(', ')

		title += ' )'

	} else {

		if (params.showRegistrationNumber && technic?.registration_number) {
			title += ` (${technic.registration_number})`
		}
		if (params.showHouseholdNumber && technic?.household_number) {
			title += ` (${technic.household_number})`
		}
		if (params.showVinNumber && technic?.vin_number) {
			title += ` (${technic.vin_number})`
		}
		if (params.showInventoryNumber && technic?.inventory_number) {
			title += ` (${technic.inventory_number})`
		}
	}
	if (params.showSecondNumber && technic?.inner_number) {
		title += ` ${technic.inner_number}`
	}
	return title || params.titleIfEmpty
}
